import React from 'react'
import './Privacy.css'

const Privacy = () => {
  return (
    <>
      <div className="privacy-container1" id='privacy'>
        <h2>Privacy Policy</h2>
      </div>
      <div className='privacy-container2'>
        <p>At moomagic , we understand the importance of protecting the privacy of our users. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our website.

          <br />1.Information We Collect:
          We may collect personal information from you when you use our website, including your name, email address, phone number, and payment information. We may also collect non-personal information, such as your IP address, browser type, and device type.

          <br />2.How We Use Your Information:
          We use your personal information to operate and improve our website, to communicate with you, and to provide you with the products and services you request. We may also use your information to send you marketing communications and to personalize your experience on our website.

          <br />3.How We Protect Your Information:
          We take appropriate measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. We use industry-standard security measures, such as encryption, to protect your information.

          <br />4.Cookies and Other Tracking Technologies:
          We may use cookies and other tracking technologies to collect non-personal information about your use of our website. You may choose to disable cookies in your browser settings, but this may limit your ability to use certain features of our website.</p>
      </div>
    </>
  )
}

export default Privacy
